<div class="row">
  <div class="col-12">
    <nb-card accent="primary">
      <nb-card-header>
        {{ "contact" | translate }}
      </nb-card-header>
      <nb-card-body *ngIf="currentLanguageCode == 'de'">
        <p>
          Wenn Sie Unterstützung benötigen, Fragen haben oder mehr über unsere
          Produkte und Dienstleistungen erfahren möchten, können Sie uns gerne
          über einen der folgenden Kanäle kontaktieren:
        </p>
        <p>
          <span>Email: </span>
          <a href="mailto:push@ethinking.de">push@ethinking.de</a>
          <br />
          <span
            >Schreiben Sie uns eine E-Mail und unser Team wird sich so schnell
            wie möglich bei Ihnen melden.</span
          >
        </p>
        <p>
          <span>Website: </span>
          <a
            href="https://ethinking.de/push"
            target="_blank"
            rel="noopener noreferrer"
            >https://ethinking.de/push</a
          >
          <br />
          <span
            >Besuchen Sie unsere Website für weitere Informationen über unsere
            Dienstleistungen, Updates und Ressourcen.</span
          >
        </p>
        <p>
          Wir schätzen Ihr Interesse und freuen uns darauf, von Ihnen zu hören!
        </p>
      </nb-card-body>

      <nb-card-body *ngIf="currentLanguageCode == 'en'">
        <p>
          If you need assistance, have questions, or want to learn more about
          our products and services, feel free to reach out to us through any of
          the following channels:
        </p>
        <p>
          <span>Email: </span>
          <a href="mailto:push@ethinking.de">push@ethinking.de</a>
          <br />
          <span
            >Drop us an email and our team will get back to you as soon as
            possible.</span
          >
        </p>
        <p>
          <span>Website: </span>
          <a
            href="https://ethinking.de/push"
            target="_blank"
            rel="noopener noreferrer"
            >https://ethinking.de/push</a
          >
          <br />
          <span
            >Visit our website for more information about our services, updates,
            and resources.</span
          >
        </p>
        <p>We value your interest and look forward to hearing from you!</p>
      </nb-card-body>
    </nb-card>
  </div>
</div>
